<template>
  <div v-if="isActive" class="modal-popup" @click="handleOverlayClick">
    <div class="popup bluesky-popup" @click.stop>
      <div class="bluesky-form">
        <!-- Header with icon -->
        <div class="page-header">
          <div class="page-avatar">
            <img src="@/assets/img/iconsNetwork/ico-bluesky-2x.png" alt="Bluesky" />
          </div>
          <!-- <h4>{{ $t('onboarding.bluesky.modal_title') }}</h4> -->
        </div>

        <!-- Instructions -->
        <p>{{ $t('onboarding.bluesky.instruction') }}</p>

        <!-- Handle input -->
        <div class="bluesky-input-group">
          <label class="input-label">
            {{ $t('onboarding.bluesky.label_handle') }}
          </label>
          <input
            type="text"
            v-model="credentials.handle"
            :placeholder="$t('onboarding.bluesky.placeholder_handle')"
            class="input-field"
            @keyup.enter="handleConnect"
            ref="handleInput"
          />
        </div>

        <!-- Password input -->
        <div class="bluesky-input-group">
          <label class="input-label">
            {{ $t('onboarding.bluesky.label_password') }}
          </label>
          <input
            type="password"
            v-model="credentials.password"
            :placeholder="$t('onboarding.bluesky.placeholder_password')"
            class="input-field"
            @keyup.enter="handleConnect"
          />
        </div>

        <!-- Buttons -->
        <div class="buttons">
          <div
            class="button btn-outline-primary"
            @click="handleCancel"
          >
            {{ $t('onboarding.bluesky.button_cancel') }}
          </div>
          <div
            class="button btn-primary"
            :class="{ 'loading': isConnecting }"
            :disabled="!canConnect || isConnecting"
            @click="handleConnect"
          >
            {{ isConnecting ? $t('onboarding.bluesky.button_connecting') : $t('onboarding.bluesky.button_connect') }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BlueskyModal',

  props: {
    active: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      isActive: false,
      credentials: {
        handle: '',
        password: ''
      },
      isConnecting: false
    }
  },

  computed: {
    canConnect() {
      return this.credentials.handle.trim() !== '' && this.credentials.password.trim() !== ''
    }
  },

  watch: {
    active(newVal) {
      this.isActive = newVal
      if (newVal) {
        this.$nextTick(() => {
          // Auto-focus on handle input when modal opens
          if (this.$refs.handleInput) {
            this.$refs.handleInput.focus()
          }
        })
      } else {
        // Reset form when modal closes
        this.credentials.handle = ''
        this.credentials.password = ''
        this.isConnecting = false
      }
    }
  },

  methods: {
    handleOverlayClick(event) {
      // Close modal when clicking on overlay (not on popup content)
      if (event.target.classList.contains('modal-popup')) {
        this.handleCancel()
      }
    },

    handleCancel() {
      if (this.isConnecting) return
      this.isActive = false
      this.$emit('cancel')
    },

    handleConnect() {
      if (!this.canConnect || this.isConnecting) return
      
      this.isConnecting = true
      this.$emit('connect', {
        handle: this.credentials.handle,
        password: this.credentials.password
      })
    },

    // Called by parent to reset loading state
    resetLoading() {
      this.isConnecting = false
    },

    // Called by parent to close modal
    close() {
      this.isActive = false
    }
  }
}
</script>

<style scoped lang="scss">
@import '../variables.scss';

.bluesky-popup {
  max-width: 480px;
}

.bluesky-form {
  .page-header {
    text-align: center;
    margin-bottom: 24px;

    .page-avatar {
      width: 56px;
      height: 56px;
      margin: 0 auto 12px;
      border-radius: 50%;
      overflow: hidden;
      background: $bg-ui-selected;
      display: flex;
      align-items: center;
      justify-content: center;

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }

    h4 {
      margin: 0;
      color: #111827;
      font-size: 18px;
    }
  }


  .bluesky-input-group {
    margin-bottom: 16px;

    .input-label {
      display: block;
      font-size: 14px;
      font-weight: 500;
      color: #374151;
      margin-bottom: 8px;
    }

    .input-field {
      width: 100%;
      padding: 12px 16px;
      font-size: 14px;
      border: 1px solid #d1d5db;
      border-radius: 8px;
      transition: all 0.2s ease;

      &:focus {
        outline: none;
        border-color: $primary-color;
        box-shadow: 0 0 0 3px rgba($primary-color, 0.1);
      }

      &::placeholder {
        color: #9ca3af;
      }
    }
  }

  .buttons {
    display: flex;
    gap: 12px;
    margin-top: 20px;
  }

  .button {
    &.loading {
      opacity: 0.7;
      cursor: not-allowed;
      pointer-events: none;
    }
  }
}
</style>
